import React from 'react';
import format from 'date-fns/format';
import { Icon } from 'semantic-ui-react';
import HeaderInfoTooltip from '../HeaderInfoTooltip/HeaderInfoTooltip';
import { getNestedValue } from '../../utils/utils';
import { colors } from '../../styles/utils';

import params from '../../utils/queryParams';

export default class CSVExport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      csvData: ''
    };
  }
  getActiveFilters = () => {
    const pageFilters = params.getAll();

    const activeFilters = [];
    this.props.filterCategories.forEach((fc) => {
      const sf = pageFilters[fc.name];
      if (!sf) {
        return;
      }
      const sfValues = sf
        .split('|')
        .filter((f) => !!f)
        .join(' / ');
      if (sf) {
        activeFilters.push(`${fc.title}: ${sfValues}`);
      }
    });
    return activeFilters.join('; ');
  };

  getRowValue = (val) => {
    let newVal = val || '';
    if (Array.isArray(val)) {
      newVal = `"${val.join(', ')}"`;
      //} else if (typeof val === 'string') {
      //newVal = val.replace(/,/g, '",');
    } else if (typeof val === 'string' && val.indexOf(',') !== -1) {
      newVal = `"${val}"`;
    }
    return newVal;
  };

  generateCSV = () => {
    const { pageName, filename, tableColumns, data } = this.props;

    let fields = tableColumns.map((f) => {
      return { label: f.name, value: f.csvKey || f.key || f.dataKey };
    });
    let formattedData = data.map((row) => {
      const newRow = {};

      tableColumns.forEach((col) => {
        const val = getNestedValue(col.dataKey || col.key, row);
        newRow[col.dataKey || col.key] =
          typeof col.csvFormatter === 'function'
            ? col.csvFormatter(val, row)
            : val;
      });
      return newRow;
    });

    const csvRows = [];
    formattedData.forEach((row, i) => {
      if (i === 0) {
        // first row, lets add the column headers
        csvRows.push(fields.map((col) => col.label || '').join(','));
      }
      csvRows.push(
        fields.map((col) => this.getRowValue(row[col.value])).join(',')
      );
    });

    const csv = csvRows.join('\n');

    const csvContent = `Corsica Client Portal Export - ${pageName}\n${format(
      new Date(),
      'MMMM Do YYYY h:mma'
    )}\n${this.getActiveFilters() || ''}\n\n${csv}`;

    const blob = new Blob([csvContent], {
      type: 'text/csv'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // brwoser hack to specify IE and Edge
      window.navigator.msSaveBlob(blob, filename);
    } else {
      // Everything other than IE and Edge

      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob, {
        type: 'text/csv'
      });
      downloadLink.download =
        filename ||
        `CCP_${this.fileNameify(pageName)}_${format(
          new Date(),
          'MM-DD-YYYY'
        )}.csv`;
      downloadLink.click();
    }
  };

  fileNameify = (str) => {
    return str.replace(/([^a-z0-9 -]+)/gi, '').replace(/ /g, '_');
  };

  render() {
    return (
      <HeaderInfoTooltip content="Download CSV">
        <Icon
          onClick={this.generateCSV}
          name="download"
          link
          style={{
            lineHeight: '34px',
            background: colors.mutedSlate,
            color: '#fff',
            height: '34px',
            width: '34px',
            borderRadius: '2px'
          }}
        />
      </HeaderInfoTooltip>
    );
  }
}
